import React, { useState } from "react";
import PropTypes from "prop-types";
import { Outlet, useLocation } from "react-router-dom";

import { Layout, theme } from "antd";
import MyHeader from "./Header";
import MySidebar from "./Sidebar";
import "./index.css";
const { Content, Footer } = Layout;
const footerStyle = {
  textAlign: "center",
};

const AntLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(true);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const location = useLocation(); // Get the current location
  //console.log(location.pathname);
  //const currentPath = location.pathname.split("/").pop();
  //console.log(currentPath);

  function getIdx(path) {
    var idx = "";
    switch (path) {
      case "/":
        idx = "0";
        break;
      case "/webmap":
      case "/stunting":
        idx = "1";
        break;
      case "/unduh":
      case "/unduh/batnas":
      case "/unduh/demnas":
      case "/unduh/rbi-wilayah":
      case "/unduh/rbi-sumatra":
      case "/unduh/rbi-cetak-10k":
      case "/unduh/rbi-cetak-25k":
      case "/unduh/rbi-cetak-50k":
      case "/unduh/rbi-cetak-100k":
      case "/unduh/rbi-cetak-250k":
        idx = "2";
        break;
      case "/tools":
      case "/tools/palapa":
        idx = "4";
        break;
      case "/kontak":
        idx = "5";
        break;
      case "/bantuan":
        idx = "6";
        break;
      case "/daftar":
      case "/lupa-password":
      case "/login":
        idx = "";
        break;
      default:
        idx = "99";
    }

    return idx;
  }
  const key = getIdx(location.pathname);
  const style_akun = {
    margin: "16px",
    minHeight: 280,
    background: colorBgContainer,
    borderRadius: borderRadiusLG,
    background: `url('${
      process.env.PUBLIC_URL + "/static/images/login.jpg"
    }') no-repeat center center`,
    backgroundSize: "cover",
  };

  const style_normal = {
    margin: "16px",
    minHeight: 280,
    background: colorBgContainer,
    borderRadius: borderRadiusLG,
  };
  return (
    <Layout
      style={{
        height: "100%",
      }}
    >
      <MySidebar collapsed={collapsed} idx={key} />
      <Layout>
        <MyHeader
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          colorBgContainer={colorBgContainer}
        />
        <Content style={key == "" ? style_akun : style_normal}>
          {children || <Outlet />}
        </Content>
        <Footer style={footerStyle}>
          &copy; {new Date().getFullYear()} Badan Informasi Geospasial. All
          rights reserved.
        </Footer>
      </Layout>
    </Layout>
  );
};

AntLayout.propTypes = {
  children: PropTypes.node,
};

export default AntLayout;
